import React, { useEffect, useState } from 'react';
import { Input, Header, Button, Grid, List } from 'semantic-ui-react';
import { useSubstrate } from './substrate-lib';
import moment from 'moment';

function Main(props){
  const { api } = useSubstrate();
  
  let [searchValue, setSearchValue] = useState("");
  let [searchResult, setSearchResult] = useState({number: "", hash: ""});
  
  function doSearch(e) {    
    e.preventDefault();    
    if(searchValue.length < 1) return;
    console.log('searching....', searchValue);
    try {
      if(searchValue.trim().substr(0,2) == "0x"){
        //hash suplied
        api.rpc.chain.getHeader(searchValue).then( block => {
          let parsed = JSON.parse(JSON.stringify(block));
          setSearchResult({number: parsed.number, hash: searchValue});
        }).catch( e => {
          badSearch();
        });
      } else {
        api.rpc.chain.getBlockHash(searchValue).then( hash => {
          console.log('re-searching....', hash.toHex());
          setSearchResult({hash: hash.toHex(), number: searchValue});
        }).catch( e => {
          badSearch();
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
  
  function badSearch(){
      setSearchResult({number: null, hash: 'Bad data for search'});
  }
  function searchChange(searchText){
    setSearchValue(searchText);
  }
  
    return ( 
    <div>
    <Header as='h3' dividing style={{ marginTop: '3em' }}>
      Search for blocks
    </Header>
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column width={12}>
              <Input value={searchValue} onChange={e => searchChange(e.target.value)} fluid placeholder='block number or hash' />
            </Grid.Column>
            <Grid.Column>
              <Button onClick={doSearch} color='green'>Search</Button>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
          {searchResult.hash.length > 0 ?
          <Grid.Column>
            <Header as='h5' dividing style={{ marginTop: '1em' }}>
              Search result
            </Header>
            <List>
              <List.Item>Block # {searchResult.number}</List.Item>
              <List.Item>Hash {searchResult.hash}</List.Item>
            </List>
          </Grid.Column>
          : ''
          }
          </Grid.Row>
        </Grid>
    </div>
    );
}

export default function BlockQuery (props) {
  return (
      <Main {...props} />
    ) 
}